import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutAutoRateLookup extends Layout {
    sourceRateLookup: DataSource;
    tableAutoRates: Table;
}
